// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2025-2026 Daragh Farrell

/**
 * Structured error logger for production use.
 * Replaces console.error with a utility that can be extended
 * to send errors to external services (Sentry, LogRocket, etc.)
 */

interface ErrorContext {
  component?: string;
  action?: string;
  [key: string]: unknown;
}

function logError(message: string, error?: unknown, context?: ErrorContext): void {
  if (import.meta.env.DEV) {
    console.error(message, error, context);
    return;
  }
  // Production: structured output (can be extended to external service)
  console.error(JSON.stringify({
    level: 'error',
    message,
    error: error instanceof Error ? { name: error.name, message: error.message } : error,
    ...context,
    timestamp: new Date().toISOString(),
  }));
}

function logWarn(message: string, context?: ErrorContext): void {
  if (import.meta.env.DEV) {
    console.warn(message, context);
    return;
  }
  console.warn(JSON.stringify({
    level: 'warn',
    message,
    ...context,
    timestamp: new Date().toISOString(),
  }));
}

export const logger = { error: logError, warn: logWarn };
export default logger;
